import classnames from 'classnames';
import dibsCss from 'dibs-css';

import styles from './PdpSharedSocialShare.scss';

export default {
    icon: classnames(styles.icon),
    iconWithLabelVariant: classnames(
        styles.iconWithLabelVariant,
        dibsCss.flex,
        dibsCss.mbXsmall,
        dibsCss.textNoir,
        dibsCss.gapXXsmall
    ),

    iconBubbleVariant: classnames(
        styles.iconBubbleVariant,
        dibsCss.flex,
        dibsCss.itemsCenter,
        dibsCss.justifyCenter,
        dibsCss.mxXsmall,
        dibsCss.textSatan,
        dibsCss.roundedFull
    ),
    iconVariant: classnames(styles.iconVariant, dibsCss.flex, dibsCss.textSatan, dibsCss.pXsmall),
    facebook: styles.facebook,
    pinterest: styles.pinterest,
};
